module.exports = __webpack_public_path__ + "img/icon_star_border.3ab2f6fb.svg";